import { Component, inject, OnInit } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { AuthService } from '../providers/auth.service';
import { SidebarService } from '../providers/sidebar.service';
import { CommonModule, KeyValue } from '@angular/common';
import { DbService } from '../providers/db.service';
import { FormsModule, NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CategoryInterface, PaymentMethodsInterface, PeriodsInterface, PMInterface, SubCategoryInterface, TransactionsInterface } from '../interfaces';

@Component({
    selector: 'app-input',
    standalone: true,
    imports: [TranslocoDirective, CommonModule, FormsModule],
    templateUrl: './input.component.html',
    styleUrl: './input.component.css'
})
export class InputComponent implements OnInit {
    public db = inject(DbService);
    public auth = inject(AuthService);
    private translocoService = inject(TranslocoService);
    private toastr = inject(ToastrService);
    public sb = inject(SidebarService);
    showToast(toastType: string, title: string, content?: string) {
        const varTimeOut = 3000;
        const varProgressBar = true;
        const varPositionClass = 'toast-top-center';
        if (toastType === 'success') {
            this.toastr.success(content, title, {
                timeOut: varTimeOut,
                progressBar: varProgressBar,
                positionClass: varPositionClass
            });
        } else if (toastType === 'info') {
            this.toastr.info(content, title, {
                timeOut: varTimeOut,
                progressBar: varProgressBar,
                positionClass: varPositionClass
            });
        } else {
            this.toastr.error(content, title, {
                timeOut: varTimeOut,
                progressBar: varProgressBar,
                positionClass: varPositionClass
            });
        }
    }



    // totals = {
    //     total: 0,
    //     ultimateTotal: 0
    // };
    showSpinner = true;
    showButtonSpinner = false;
    selectedCategory = -1;
    selectedSubCategory = -1;
    selectedMethod = '';
    catsArray: CategoryInterface[] = [];
    disabledDescription = true;
    complexInputForm = true;
    isPaymentMethodsDefault = true;
    subCatsArray: SubCategoryInterface[] = [];
    periodsArray: PeriodsInterface[] = [];
    payments: PMInterface;
    defaultPaymentMethod: string[] = [];
    defaultDate = new Date();
    defaultTransactionModel = {
        Method: 'default',
        Account: 'default',
        Category: 'Select Category',
        SubCategory: 'null'
    };

    transactionModel: TransactionsInterface = {
        ID: 0,
        Amount: undefined,
        Date: this.defaultDate.toISOString().substring(0, 10),
        Category: 'Select Category',
        SubCategory: 'null',
        Description: 'null',
        Where: 'null',
        Method: 'default',
        Account: 'default',
        catID: 'null',
        period: -1,
        hash: 0
    };

    sortByValueAsc = <T>(a: KeyValue<string, T>, b: KeyValue<string, T>) => {
        return a.key.localeCompare(b.key);
    };
    ngOnInit(): void {
        this.ngOnInitAsync()
    }

    async ngOnInitAsync() {
        try {
            await this.listOfAllCats();
            await this.listOfPaymentMethods();
            // this.totals = await this.db.getTotalsAsync(this.auth.currentUserIDSig().uid);
            await this.listofAllPeriods()
            this.showSpinner = false;
        } catch (err) {
            console.log(err.code)
        }
    }
    async listOfAllCats() {
        try {
            this.catsArray = await this.db.getCatsAsync(this.auth.currentUserIDSig().uid);
        } catch (err) {
            console.log(err.code)
        }
    }

    async listOfPaymentMethods() {
        try {
            this.payments = await this.db.getPaymentMethodsAsync(this.auth.currentUserIDSig().uid) as PMInterface;
            this.defaultPaymentMethod.push("method".concat(this.payments['default'].substring(0, 1)))
            this.defaultPaymentMethod.push("source".concat(this.payments['default'].substring(2, 3)))
            this.transactionModel.Method = this.payments[this.defaultPaymentMethod[0]].name
            this.transactionModel.Account = this.payments[this.defaultPaymentMethod[0]][this.defaultPaymentMethod[1]].name
            this.defaultTransactionModel.Method = this.payments[this.defaultPaymentMethod[0]].name
            this.defaultTransactionModel.Account = this.payments[this.defaultPaymentMethod[0]][this.defaultPaymentMethod[1]].name
            this.transactionModel.Where = null
            this.transactionModel.Description = null
            this.transactionModel.Amount = null
            delete this.payments.default
        } catch (err) {
            console.log(err.code)
        }
    }

    buildHashInput(trans: TransactionsInterface): string {
        const amount = trans.Amount ?? 0
        const date = trans.Date ?? 0
        const where = (trans.Where ?? 0).toString().replace(/\s+/g, "").toLowerCase();
        return [
            amount.toString(),
            date.toString(),
            where
        ].join("|");
    }

    simpleHash(str: string): number {
        let hash = 5381;
        for (let i = 0; i < str.length; i++) {
            hash = (hash * 33) ^ str.charCodeAt(i);
        }
        return hash >>> 0;
    }

    async listofAllPeriods() {
        try {
            this.periodsArray = await this.db.getPeriodsAsync(this.auth.currentUserIDSig().uid);
        } catch (err) {
            console.log(err.code)
        }
    }

    async listOfSubCats(catObject: string): Promise<void> {
        const catID = catObject;
        try {
            this.subCatsArray = await this.db.getSubCatListAsync(catID, this.auth.currentUserIDSig().uid);
        } catch (err) {
            console.error('Error while fetching subcategories:', err);
        }
    }

    async onSubmit(transModel: TransactionsInterface, catID: string, TransactionForm: NgForm) {
        const rawDate = this.db.currentUserDataSig()?.regDate;
        const regDate = new Date(rawDate as unknown as string);
        const transDate = new Date(transModel.Date)
        if (transDate < regDate || transDate > new Date(this.defaultDate.toISOString().substring(0, 10))) {
            console.log('Incorrect data.')
        } else {
            if (!this.isPaymentMethodsDefault) {
                transModel.Method = this.db.currentPaymentMethodsSig()[this.transactionModel.Method].name
            }
            this.showButtonSpinner = true;

            const year = transDate.getFullYear();
            const month = transDate.getMonth() + 1;
            const period = Number(`${year}${month.toString().padStart(2, '0')}`);

            transModel.period = period;
            let periodDocID = 'xxx';
            transModel.catID = catID;

            for (const per of this.periodsArray) {
                if (per.content['periodID'] === period) {
                    periodDocID = per.id
                }
            }
            try {
                // this.totals.total++;
                // this.totals.ultimateTotal++;
                // transModel.ID = 999999999; 
                // this.totals.ultimateTotal;
                transModel.hash = this.simpleHash(this.buildHashInput(this.transactionModel));
                transModel.Amount = Number(transModel.Amount);
                console.log("Sending to function:", { model: transModel, userid: this.auth.currentUserIDSig().uid });
                await this.db.addTransactionAsync(transModel, this.auth.currentUserIDSig().uid);
                // await this.db.setTotalsAsync('add', this.auth.currentUserIDSig().uid)
                // this.totals = await this.db.getTotalsAsync(this.auth.currentUserIDSig().uid)

                // await this.db.updateExpenseInPeriodsAsync(1, transModel.Amount, periodDocID, this.auth.currentUserIDSig().uid);
                // await this.db.updateExpenseInCategoriesAsync(period, transModel.Amount, catID, this.auth.currentUserIDSig().uid);
                TransactionForm.resetForm();
                setTimeout(() => {
                    this.restoreFormDefaults()
                }, 100);
                this.showToast('success', `${this.translocoService.translate('toasts.inputSuccessMessageParamAddTransactionNoCounter', undefined, this.auth.currentUserSig()?.lang)}`)
                this.showButtonSpinner = false;
            }
            catch (err) {
                console.log(err.code)
                this.showToast('error', `${this.translocoService.translate('toasts.inputFailMessageAddTransaction', undefined, this.auth.currentUserSig()?.lang)}`)
                this.showButtonSpinner = false;
            }
        }
    }


    restoreFormDefaults() {
        this.transactionModel.Category = this.defaultTransactionModel.Category;
        this.transactionModel.SubCategory = this.defaultTransactionModel.SubCategory;


        if (this.isPaymentMethodsDefault) {
            this.transactionModel.Method = this.defaultTransactionModel.Method
            this.transactionModel.Account = this.defaultTransactionModel.Account
        } else {
            this.transactionModel.Method = 'default'
            this.transactionModel.Account = 'default'
        }
        this.transactionModel.Amount = undefined;
        this.transactionModel.Where = null;
        this.setDate('today');
    }

    toggleFormComplexity() {
        this.complexInputForm = !this.complexInputForm;
    }

    togglePaymentMethods() {
        this.isPaymentMethodsDefault = !this.isPaymentMethodsDefault;
        if (this.isPaymentMethodsDefault) {
            this.transactionModel.Method = this.defaultTransactionModel.Method
            this.transactionModel.Account = this.defaultTransactionModel.Account
        } else {
            this.transactionModel.Method = 'default'
            this.transactionModel.Account = 'default'
        }
    }

    paymentMethodSelector(methodFromForm: string) {
        this.selectedMethod = methodFromForm;
    }

    addDays(date: Date, days: number) {
        const newDate = new Date(date);
        if (days == -30) {
            newDate.setDate(0);
        } else {
            newDate.setDate(date.getDate() + days);
        }
        return newDate;
    }

    setDate(type: string) {
        let transactionDate;
        const defDate = new Date();
        if (type === 'today') {
            transactionDate = new Date().toISOString().substring(0, 10);
        }
        else if (type === 'yesterday') {

            const newDate = this.addDays(defDate, -1);
            transactionDate = newDate.toISOString().substring(0, 10)
        } else if (type === 'lastWeek') {

            const newDate = this.addDays(defDate, -7);
            transactionDate = newDate.toISOString().substring(0, 10)
        } else if (type === 'lastMonth') {

            const newDate = this.addDays(defDate, -30);
            transactionDate = newDate.toISOString().substring(0, 10)
        } else {
            console.log('error');
        }
        this.transactionModel.Date = transactionDate!;
    }
}